import { z } from 'zod';

// Member account status — the single declaration of the `members.status`
// text+CHECK domain (ADR-056 Rule 8). It lives in its own module rather than
// beside the wire schemas so the persistence layer can derive a CHECK from the
// same tuple without importing a response module, which would invert the
// ADR-001 layering (schema is below the wire contract, not above it).
export const MEMBER_STATUS = ['active', 'disabled', 'deleted'] as const;
export const memberStatusSchema = z.enum(MEMBER_STATUS);
export type MemberStatus = z.infer<typeof memberStatusSchema>;
